import { CMS_PAGES } from './actionTypes';

const initialState = {
  pageBanner: [],
  loading: {
    pageBanner: false,
  },
  error: {
    pageBanner: null,
  },
};

const CmsPagesReducer = (state = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case CMS_PAGES.CMS_PAGES_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, pageBanner: true },
        error: { ...state.error, pageBanner: null },
      };
    case CMS_PAGES.CMS_PAGES_SUCCESS:
      return {
        ...state,
        pageBanner: payload && payload.result.data,
        loading: { ...state.loading, pageBanner: false },
      };
    case CMS_PAGES.CMS_PAGES_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, pageBanner: false },
        error: { ...state.error, pageBanner: error },
      };
    default:
      return state;
  }
};

export default CmsPagesReducer;
